import axios from 'axios';
import { ROUTE_PATHS, STATIC_ROUTES } from '../routes/Routes';
import qs from 'qs';

export const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:3000/api';

const CustomAxios = axios.create({
  withCredentials: true,
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  paramsSerializer: (params) => {
    return qs.stringify(params, { arrayFormat: 'brackets' });
  },
});

CustomAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      const { pathname = '', search = '' } = window.location;
      sessionStorage.setItem(STATIC_ROUTES.REDIRECT_PATH_AFTER_LOGIN, `${pathname + search}`);

      window.location.href = ROUTE_PATHS.LOGIN;
    } else {
      return Promise.reject(error);
    }
  }
);

export default CustomAxios;
